<template>
  <router-view></router-view>
</template>
<script>
export default {
  name: "contact",
  data() {
    return {}
  },
}
</script>
